





import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
  name: 'BaseSelectOption',
  props: {
    value: {
      type: [String, Number, Object],
      default: '',
    },
  },
});
